import Backbone from 'backbone'

const ChartDesignerForecast = Backbone.Model.extend({})

export default ChartDesignerForecast

ChartDesignerForecast.__filename__ = 'charts/model/chart-designer-forecast.js'
